<template>
  <div class="face-container">
    <div style="margin-top: 20px;">
      <el-row :gutter="10">
        <el-col :xs="24" :md="12" :lg="14" style="margin-bottom:30px;">
          <div class="biaoqian">视频选择</div>
          <el-card class="box-card" style="border-radius:10px;" shadow="never">
            <div>
              <div style="padding: 15px 10px;background-color: #f5f5f5;border-radius: 8px;
              background: linear-gradient(to right, #262626, #262626);color: #fff;">
                <div style="font-size: 13px;display: flex;align-items: center;justify-content: center;">
                  <i class="el-icon-info" style="margin-right: 5px;"></i>
                  视频选择注意事项
                </div>
                <div style="
              font-size: 13px;display: flex;align-items: center;justify-content: space-between;
              margin-top: 15px;">
                  <div style="display: flex;align-items: center;">
                    <div style="margin-right: 5px;">
                      多人视频
                    </div>
                    <i class="el-icon-close" style="color: #ff2427;"></i>
                  </div>
                  <div style="display: flex;align-items: center;">
                    <div style="margin-right: 5px;">
                      脸部遮挡
                    </div>
                    <i class="el-icon-close" style="color: #ff2427;"></i>
                  </div>
                  <div style="display: flex;align-items: center;">
                    <div style="margin-right: 5px;">
                      吃饭化妆
                    </div>
                    <i class="el-icon-close" style="color: #ff2427;"></i>
                  </div>
                  <div style="display: flex;align-items: center;">
                    <div style="margin-right: 5px;">
                      单人露脸
                    </div>
                    <i class="el-icon-check" style="color: #30e215;"></i>
                  </div>
                </div>
              </div>

              <div style="margin-top: 20px;">
                <qhyupload ref="uploadvideo" type="AI去重" kcds="30秒/2点" maxtime="8分钟"></qhyupload>
              </div>

              <div style="margin: 20px 5px;">
                <el-divider></el-divider>
              </div>

              <div v-if="hj_url.length > 0">
                <div class="biaoqian">已选视频</div>
                <div style="margin-top: 15px;padding: 10px 15px;background-color: #f5f5f5;border-radius: 8px;"
                  v-if="hj_url.length > 0">
                  <div style="font-size: 16px;color: #393939;display: flex;justify-content: space-between;
                margin: 10px 0px;align-items: center;" v-for="(item, index) in hj_url" :key="index">
                    <div
                      style="white-space: nowrap;display: block;overflow: hidden;text-overflow: ellipsis;width: 90%;">
                      {{ item.url }}
                    </div>
                    <div style="width: 10%;display: flex;justify-content: flex-end;" @click="hj_url.splice(index, 1)">
                      <i class="el-icon-circle-close" style="color: #a5a5a5;"></i>
                    </div>
                  </div>
                </div>
                <div style="margin: 20px 5px;">
                  <el-divider></el-divider>
                </div>
              </div>

              <!-- 整合人脸设置模块 -->
              <div style="margin-top: 15px;">
                <div style="margin:10px 0px;font-weight: 600;color: #666;">人脸设置</div>
                <div style="display: flex;align-items: center;justify-content: space-between;padding:15px 10px;
                background-color: #f5f5f5;border-radius: 10px;cursor: pointer;"
                  @click="$router.push('/user/face-setting')">
                  <div style="font-size: 16px;">
                    选择人脸素材
                  </div>
                  <div style="display: flex;align-items: center;font-size: 14px;color: #6a6a6a;">
                    <div v-if="face">
                      <el-avatar :src="face" size="36"></el-avatar>
                    </div>
                    <div v-else>
                      未选择
                    </div>
                    <div style="margin-left: 8px;">
                      <i class="el-icon-arrow-right" style="color: #3e3e3e;"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div style="margin: 15px 5px;">
                <el-divider></el-divider>
              </div>

              <!-- 整合高级设置模块 -->
              <div style="margin-top: 15px;">
                <div style="margin:10px 0px;font-weight: 600;color: #666;">高级设置</div>
                <div style="margin-top: 10px;display: flex;flex-wrap: wrap;">
                  <div style="display: flex;flex-wrap: wrap;font-size: 13px;color: #fff;">
                    <div v-for="(item, index) in qc_list" :key="index"
                      style="background-color: #eaeaea;border-radius: 0.5vh;display: flex;justify-content: center;align-items: center;padding: 7px 14px;color: #5a5a5a;margin: 6px;cursor: pointer;font-size: 0.8rem;min-width: 4rem;"
                      @click="qc_list[index].check = (qc_list[index].check === 1 ? 0 : 1)"
                      :style="{ backgroundColor: (item.check === 1 ? '#484add' : '#eaeaea'), color: (item.check === 1 ? '#fff' : '#5a5a5a') }">
                      <div class="no-select">{{ item.name }}</div>
                    </div>
                  </div>
                </div>

                <div style="display: flex;justify-content: space-between;font-size: 14px;margin-top: 15px;">
                  <div style="width: 47%;cursor: pointer;"
                    @click="ylms = 'https://video.kissxx.cn/src_img/jiaocheng/face_jc.mp4'">
                    <div style="padding: 10px 0px;display: flex;">
                      <i class="el-icon-check" style="color: #28b912;"></i>
                      <div style="margin-left: 6px;">使用教程</div>
                    </div>
                    <div style="position: relative;">
                      <el-image :src="'https://video.kissxx.cn/src_img/jiaocheng/face_jc2.jpg'"
                        style="width: 100%;height: 180px;border-radius: 10px;"></el-image>
                    </div>
                  </div>
                  <div style="width: 47%;cursor: pointer;"
                    @click="ylms = 'https://video.kissxx.cn/src_img/jiaocheng/face_xg.mp4'">
                    <div style="padding: 10px 0px;display: flex;">
                      <i class="el-icon-view" style="color: #b95d28;"></i>
                      <div style="margin-left: 6px;">事例&效果</div>
                    </div>
                    <el-image :src="'https://video.kissxx.cn/src_img/jiaocheng/face_xg2.jpg'"
                      style="width: 100%;height: 180px;border-radius: 10px;"></el-image>
                  </div>
                </div>
              </div>

              <div class="msyl_fc" v-if="ylms">
                <video style="height: 50%;" :src="ylms" autoplay controls></video>
                <div style="display: flex;justify-content: center;align-items: center;
                  margin-top: 20px;cursor: pointer;" @click="ylms = ''">
                  <div style="background-color: #f0f0f0;border-radius: 50px;padding: 10px;">
                    <i class="el-icon-close" style="color: #444444;"></i>
                  </div>
                </div>
              </div>

              <!-- 开始制作按钮 -->
              <div style="margin-top: 20px;">
                <div
                  style="display: flex;justify-content: center;height: 40px;align-items: center;background-color: #484add;color: #fff;border-radius: 5px;border: 1px solid #5b2daf;cursor: pointer;"
                  @click="ks" :style="'pointer-events:' + (upload_text ? 'none' : '')">
                  开始制作
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="24" :md="12" :lg="10">
          <div class="biaoqian">制作记录</div>
          <el-card class="box-card" style="border-radius:10px;" shadow="never">
            <div style="font-size: 14px;">
              <Record ref="record"></Record>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-dialog title="特别声明" :visible.sync="tishi" append-to-body width="500px" center>
        <div style="padding: 10px;">
          <div style="color: #464646;font-size:16px;margin: 20px 0px;">
            <div style="margin-top: 10px;">本产品使用人脸融合技术，皆在艺术创作和娱乐，无意损害个人形象或著作权。原始素材归原作者所有，
              制作的视频都会被审核，若用户滥用此功能实施侵权或违法行为，用户应自行承担由此产生的法律责任。我们承诺您上传的图片只用于制作娱乐视频效果,不向任何第三方透露,且不用于任何商业用途,用户随时可以删除</div>
          </div>
          <div style="display: flex;justify-content: space-between;margin-top: 30px;">
            <div style="width: 47%;">
              <el-button size="medium" @click="tishi = false" style="width: 100%;">拒绝</el-button>
            </div>
            <div style="width: 47%;">
              <el-button type="primary" size="medium" @click="ks" style="width: 100%;">我已知晓</el-button>
            </div>
          </div>
        </div>
      </el-dialog>

      <div v-if="showToast" class="custom-toast">
        <div class="toast-content">{{ toastMessage }}</div>
      </div>
    </div>
  </div>

</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import qhyupload from '@/components/common/qhyupload.vue';
import Record from "@/components/User/Record.vue";

export default {
  name: 'Face',
  components: {
    qhyupload,
    Record
  },
  // 定义属性
  data() {
    return {
      max_files: 10,
      hj_url: [],
      upvideo_list: [],
      inputs: {
        'padding': '10px 20px',
        'border-color': '#838383 !important'
      },
      paste_msg: true,
      ui: {
        surplus: '0',
        hz: '1080p',
      },
      fileList1: [],
      mb: 0,
      upload_info: [],
      upload_text: '',
      face: false,
      qc_list: [
        { name: '镜像翻转', check: 0 },
        { name: '上下开幕', check: 0 },
        { name: '左右开幕', check: 0 }
      ],
      tishi: false,
      tishi_look: 0,
      ylms: '',
      showToast: false,
      toastMessage: ''
    }
  },
  created() {
    // 从URL参数获取kuaijie
    if (this.$route.query.kuaijie) {
      this.hj_url.push({
        'url': this.$route.query.kuaijie,
        'music': 0,
        'kt': 0
      })
    }
    // 从本地存储获取tishi_look
    this.tishi_look = localStorage.getItem('tishi_look') || 0;
    // 获取配置信息
    this.$ajax.get('qhy/user/ms').then(res => {
      console.log(res)
      if (res.data.status == 200) {
        this.mb = (res.data.set.mb * 1024) * 1024
      }
    })
  },
  mounted() {
    // 监听人脸选择事件
    const that = this;
    this.$bus.$on('face', function (data) {
      that.face = data;
    });
  },
  methods: {
    // 获取用户信息
    async get_ui() {
      try {
        // 假设common.js中有get_user方法
        const ui2 = await this.common.get_user();
        console.log('ui', ui2)
        this.ui = ui2
      } catch (error) {
        console.error('获取用户信息失败:', error);
      }
    },
    // 处理视频过大的情况
    upvideo_big(e) {
      this.showToastMessage(`不支持大于${(this.mb / 1024 / 1024).toFixed(2)}MB的视频`);
    },
    // 删除图片
    deletePic(event) {
      this[`fileList${event.name}`].splice(event.index, 1)
    },
    // 读取文件后处理
    async afterRead(event) {
      const that = this;
      let lists = [].concat(event.file)
      let fileListLen = this[`fileList${event.name}`].length
      if (fileListLen > 9) {
        this.showToastMessage('一次最多可上传10个视频');
        return
      }
      if (that.hj_url.length >= that.max_files) {
        this.showToastMessage(`最多可上传${that.max_files}个视频`);
        return
      }
      lists.map((item) => {
        this[`fileList${event.name}`].push({
          ...item,
          status: 'uploading',
          message: '上传中'
        })
      })
      for (let i = 0; i < lists.length; i++) {
        console.log(lists[i])
        const result = await this.uploadFilePromise2(lists[i], fileListLen)
        if (result == null) {
          this.showToastMessage('上传失败');
          return
        }
        this.upload_text = ''
        this.hj_url.push({
          'url': result,
          'music': 0,
          'kt': 0
        })
        // 存储上传记录
        localStorage.setItem('upload_record', JSON.stringify({
          'url': result,
          'type': '人脸融合'
        }));
        this.showToastMessage('上传成功');
        fileListLen++
      }
    },
    // 上传文件的Promise封装
    uploadFilePromise2(url, index) {
      return new Promise((resolve, reject) => {
        const vm = this;
        const that = this;

        // 获取上传信息
        const getUploadInfo = function (extName, callback) {
          vm.$ajax.post('qhy/user/balance_xy_web', {
            num: 1,
            xgcs: 1
          }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
            if (res.data.status == 100) {
              vm.showToastMessage(res.data.msg);
              return
            }
            if (vm.upload_info.length == 0) {
              vm.upload_info = res.data
            }
            callback && callback(null, vm.upload_info);
          }).catch(err => {
            console.error('获取上传信息失败:', err);
            callback && callback(err);
          })
        };

        // 上传文件
        const uploadFile = function (opt, callback) {
          const formData = {
            token: opt.token
          };

          const uploadTask = new XMLHttpRequest();
          uploadTask.open('POST', opt.upload_url);
          uploadTask.onload = function () {
            if (uploadTask.status >= 200 && uploadTask.status < 300) {
              try {
                const jg = JSON.parse(uploadTask.responseText);
                if (jg.code != 200) {
                  return callback && callback({ status: jg.code, message: jg.msg });
                }
                const fileUrl = opt.host + jg.dz;
                callback && callback(null, fileUrl);
              } catch (e) {
                console.error('解析上传结果失败:', e);
                callback && callback(null);
              }
            } else {
              callback && callback({ status: uploadTask.status, message: '上传失败' });
            }
            that.upload_text = '';
          };
          uploadTask.onerror = function (err) {
            callback && callback(err);
            that.upload_text = '';
          };

          // 构建FormData
          const data = new FormData();
          data.append('file', url);
          for (const key in formData) {
            data.append(key, formData[key]);
          }

          uploadTask.send(data);

          // 监听上传进度
          uploadTask.upload.onprogress = function (event) {
            if (event.lengthComputable) {
              const progress = Math.round((event.loaded / event.total) * 100);
              that.upload_text = `上传中${progress}%`;
            }
          };
        };

        // 执行上传流程
        const fileName = url.name || url.url.split('/').pop();
        const lastIndex = fileName.lastIndexOf('.');
        const extName = lastIndex > -1 ? fileName.slice(lastIndex + 1) : '';

        getUploadInfo(extName, function (err, info) {
          if (err) {
            reject(err);
            return;
          }
          uploadFile(info, function (err, fileUrl) {
            if (err) {
              reject(err);
            } else {
              resolve(fileUrl);
            }
          });
        });
      })
    },
    // 显示提示消息
    showToastMessage(message) {
      this.toastMessage = message;
      this.showToast = true;
      setTimeout(() => {
        this.showToast = false;
      }, 2000);
    },
    // 开始制作
    ks() {
      const that = this;
      if (this.tishi) {
        this.tishi_look = 1;
        localStorage.setItem('tishi_look', 1);
        this.tishi = 0;
      } else {
        if (!this.tishi_look) {
          this.tishi = 1;
          return;
        }
      }

      if (!this.face) {
        this.showToastMessage('请选择人脸素材');
        return;
      }

      const url = this.$refs.uploadvideo.get_urls();
      if (url.length <= 0) {
        this.showToastMessage('请选择视频');
        return;
      }

      const other = {};
      for (let i = 0; i < this.qc_list.length; i++) {
        other[this.qc_list[i].name] = this.qc_list[i].check;
      }
      console.log(other);

      const data = {
        'url': url,
        'face': this.face,
        'type': 5,
        'other': JSON.stringify(other)
      };

      const loading = this.$loading(this.$loadinginfo);
      this.$ajax.post('qhy/user/makevieo', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
        console.log(res);
        loading.close();
        if (res.data.status == 200) {
          // 显示提交成功组件
          this.showToastMessage('制作成功');
          this.hj_url = [];
          this.$refs.uploadvideo.clear_urls();
        } else {
          this.showToastMessage(res.data.msg);
        }
      }).catch(err => {
        console.error('制作视频失败:', err);
        loading.close();
        this.showToastMessage('制作失败，请重试');
      });
    },
    // 粘贴链接
    paste() {
      const that = this;
      if (navigator.clipboard) {
        navigator.clipboard.readText().then(text => {
          if (that.hj_url.length >= that.max_files) {
            that.showToastMessage(`最多可上传${that.max_files}个视频`);
            return;
          }
          that.hj_url.push({
            'url': text
          });
        }).catch(err => {
          console.error('读取剪贴板失败:', err);
          that.showToastMessage('无法访问剪贴板，请手动粘贴');
        });
      } else {
        that.showToastMessage('浏览器不支持剪贴板API');
      }
    }
  }
}
</script>

<style scoped>
.msyl_fc {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
}


.custom-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 12px 24px;
  border-radius: 4px;
  z-index: 9999;
}

.toast-content {
  font-size: 14px;
}

.face-container {
  padding-bottom: 80px;
}

@media (max-width: 768px) {
  .face-container {
    padding: 0 10px 80px 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/face.vue